import { Component, OnInit, ViewChild, AfterContentChecked } from '@angular/core';
import { IMVOSession } from 'src/app/+data/imvo-kznc/imvo-kznc.session';
import { DepartmentConfigurationModel } from 'src/app/shared/models/department-setup.model';
import { EmployeeConfigurationModel, EmployeeSetupModel, FieldsFormat, FieldsTitle } from '../../../shared/models/employee-setup.model';
import { EmployeeSetupComponent } from 'src/app/shared/dynamic-controls/employee-setup/employee-setup.component';
import { AppCode } from 'src/app/app.code';
@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class imvoCreateUserComponent implements OnInit {
  employeeConfiguration: EmployeeConfigurationModel = new EmployeeConfigurationModel();
  departmentConfiguration: DepartmentConfigurationModel = new DepartmentConfigurationModel();
  //imvoSession: IMVOSession = new IMVOSession();
  @ViewChild('appEmployeeSetup') appEmployeeSetup: EmployeeSetupComponent;
  constructor(private imvoSession: IMVOSession, private appCode: AppCode) {
    // Employee Configuration
    
    this.imvoSession.getEmployeeConfiguration().then(async (data) => {
      this.employeeConfiguration = await data;
      this.employeeConfiguration.addFormName = "Create Profile";
      this.employeeConfiguration.displayListCardView = false;
      this.employeeConfiguration.allowAdd = true;
      this.employeeConfiguration.allowEdit = true;
      this.employeeConfiguration.addEditInModalPopUp = false;
      this.employeeConfiguration.allowedFields.profileImage = true;
      this.employeeConfiguration.allowedFields.webLogin = false;
      this.employeeConfiguration.redirectUrl = "/auth/login";      
    });
    
    // Department Configuration    
    this.imvoSession.getDepartmentConfiguration().then(async (data) => {
      this.departmentConfiguration = await data;
      this.departmentConfiguration.displayListCardView = false;
      this.departmentConfiguration.addEditInModalPopUp = false;
      this.departmentConfiguration.allowAdd = false;
      this.departmentConfiguration.allowEdit = false;
      this.departmentConfiguration.displayDepartmentDropDownList = true;
      this.departmentConfiguration.displayDepartmentDropdown = true;
      this.departmentConfiguration.displayDepartmentDropdown2 = true;
      this.departmentConfiguration.displayServiceDropdown = false;
    });
  }

  ngOnInit() {
   
  }

  ngAfterContentChecked() {
    this.appEmployeeSetup.webLoginDefaultValue('Yes');
  }
}
